import { defineStore } from 'pinia';
import {reactive, ref} from 'vue';

export const useErrorStore = defineStore('error', () => {
    const state = reactive({
        errors: null
    });
    function setErrors(errors) {
        state.errors = errors
    }
    function clearErrors() {
        state.errors = null
    }
    function clearError(field) {
        if (state.errors) {
            delete state.errors[field]
        }
    }
    return { state, setErrors, clearErrors, clearError }
});
